<template>
    <v-list class="mt-0 pt-0">
        <template v-for="(item, index) in items">
            <v-list-group v-if="item.children" :value="item.group">
                <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </template>
                <template v-for="child in item.children">
                    <v-list-group v-if="child.children" sub-group>
                        <template v-slot:activator>
                            <v-list-item-icon v-if="child.title !== 'Solicitar trámite'">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.title }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-for="(subChild, subChildIndex) in child.children" :to="subChild.route">
                            <v-list-item-icon>
                                <v-icon>{{ subChild.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ subChild.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item v-else :to="child.route" @click="onClick(child)">
                        <v-list-item-icon>
                            <v-icon>{{ child.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ child.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list-group>
            <v-list-item v-else :to="item.route" @click="onClick(item)" color="primary"
                :style="item.destacado ? { fontWeight: 'bold' } : {}">
                <v-list-item-icon>
                    <v-icon>{{ itemIcon(item) }}</v-icon>
                    <v-badge v-if="item.destacado" color="green" dot overlap>
                    </v-badge>
                </v-list-item-icon>
                <v-list-item-content :style="item.destacado ? { fontWeight: 'bold' } : {}">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>

</template>

<script>


export default {
    name: 'Menu',
    data() {
        return {
            group: null,
            toggle: false,
        }
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    methods: {
        onClick(item) {
            this.$emit('comunicaDrawer', item);
        },
        itemIcon(value) {
            return value.destacado ? value.icon.split('-outline').join('') : value.icon;
        }
    },
};

</script>